'use client'

import React from 'react'
import { PanelLeft } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useAlkanes } from '../lib/store'
import AssetCenter from './asset-center'
import TradeBox from './trade-box'
import WorkspaceRail from './workspace-rail'

/// The desktop trading workspace: left rail, center, right rail over a
/// full-height canvas, with the ticker strip pinned below. The rail is
/// always-on at xl and folds behind a toggle between lg and xl — the same
/// budget fomo web spends, since neither app pretends this layout fits a
/// phone (ours degrades to the phone APP, not to a "maximize your window"
/// wall).
///
/// The center always carries the selected market. DIESEL is the default, so
/// the desktop never duplicates the token rail with a second directory.
export default function Workspace() {
	const asset = useAlkanes((s) => s.asset)
	const [railOpen, setRailOpen] = React.useState(false)

	return (
		// Full-bleed: the workspace owns the whole width — rail flush left,
		// trade box flush right, no centering cap. The px-2 is the panels'
		// internal breathing room, not a page gutter.
		<div className="flex h-[calc(100dvh-3.5rem-2rem)] w-full gap-2 px-2 pt-2">
			{/* lg-only rail toggle; at xl the rail is simply there. */}
			<button
				type="button"
				aria-pressed={railOpen}
				aria-label={railOpen ? 'Hide token rail' : 'Show token rail'}
				data-testid="alkanes-rail-toggle"
				onClick={() => setRailOpen((o) => !o)}
				className="absolute left-2 top-[4.25rem] z-30 grid size-9 place-items-center rounded-lg bg-card text-muted-foreground transition-colors hover:text-foreground xl:hidden"
			>
				<PanelLeft className="size-4" aria-hidden="true" />
			</button>

			<div className={cn('w-[340px] shrink-0 pb-2', railOpen ? 'block' : 'hidden xl:block')}>
				<WorkspaceRail />
			</div>

			<div className="min-w-0 flex-1 pb-2">
				<AssetCenter />
			</div>

			{asset && (
				<div className="hidden w-[360px] shrink-0 pb-2 lg:block">
					{/* No key: remounting per asset wiped the rail's state (dust
					    expanded, open position, side). The box itself resets only
					    what belonged to the old asset — the typed amount. */}
					<TradeBox />
				</div>
			)}
		</div>
	)
}
